<cd-header (menuToggled)="mobileNavOpen = $event"></cd-header>

<main class="min-h-screen bg-cd-bg">
  <router-outlet></router-outlet>
</main>

<cd-footer></cd-footer>

<cd-mobile-nav [open]="mobileNavOpen" (closed)="mobileNavOpen = false"></cd-mobile-nav>
